/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "85fe6faafae101b9b2ce411438e8bb57d9e14202";
